import { ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestOptionsProvider, ErrorHandlingService } from '@cordic/request';
import { CommonModule } from '@angular/common';
import { DriverManagementService } from '@cordic/driver-management';

@NgModule({
    imports: [
      CommonModule
    ]
  })
export class DriverManagementModule {
    static forRoot(deps: [Provider & Type<HttpClient>, Provider & Type<RequestOptionsProvider>, Provider & Type<ErrorHandlingService>])
    : ModuleWithProviders<DriverManagementModule>
    {
      return {
        ngModule: DriverManagementModule,
        providers: [
          {
            provide: DriverManagementService,
            useClass: DriverManagementService,
            deps
          }
        ],
      };
    };
}